import Footer from '../partials/Footer';
import Header from '../partials/Header';

type PageProps = {
  children: React.ReactNode;
};

const Page = (props: PageProps) => {
  return (
    <div>
      <>
        <Header />
        <div className="containerFixed page-content">{props.children}</div>
        <Footer />
      </>
    </div>
  );
};

export default Page;
